// extracted by mini-css-extract-plugin
module.exports = {"Report-card-box":"c_","reportCardBox":"c_","report-img-wrap":"da","reportImgWrap":"da","report-title":"db","reportTitle":"db","report-date":"dc","reportDate":"dc"};